import MentionsLegalesI18n from './MentionsLegales.i18n.js';

export default {

  components: {},

  props: {},

  computed: {},

  data() {
    return {};
  },

  watch: {},

  methods: {
      /**
       * Fonction pour revenir à l'acceuil.
       */
      goToHome() {
        this.$router.push({
            path: '/'
        })
      },
  },

  mounted() {},

  i18n: MentionsLegalesI18n,

};
